const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || (import.meta.env.PROD ? `${window.location.origin}/api` : "http://localhost:8080/api");

import { logErrorToServer } from "../utils/errorLogger";

function generateCorrelationId() {
  return "corr_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
}

export async function api(path, options = {}) {
  const { headers: requestHeaders, ...requestOptions } = options;
  const isFormData = typeof FormData !== "undefined" && requestOptions.body instanceof FormData;
  const headers = { ...(requestHeaders || {}) };
  if (!isFormData && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  // Attach correlation ID for distributed tracing
  const correlationId = generateCorrelationId();
  headers["X-Correlation-Id"] = correlationId;

  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers,
    ...requestOptions,
  });

  if (!response.ok) {
    let message = `Request failed: ${response.status}`;
    try {
      const err = await response.json();
      if (err?.details && Object.keys(err.details).length) {
        message = Object.entries(err.details).map(([k, v]) => `${k}: ${v}`).join("; ");
      } else if (err?.message) {
        message = err.message;
      }
    } catch {
      // ignore body parse failure, keep default message
    }

    const error = new Error(message);
    error.status = response.status;
    error.requestUri = path;
    error.requestMethod = (options.method || "GET").toUpperCase();
    error.correlationId = correlationId;

    // Log API error to backend (fire-and-forget)
    logErrorToServer(error, {
      logger: "frontend-api",
      requestUri: path,
      requestMethod: (options.method || "GET").toUpperCase(),
      correlationId: correlationId,
    });

    throw error;
  }

  return response.status === 204 ? null : response.json();
}
